<template>
<Transition name="c-modal-campaign">
<div v-show="isShowCampaign" class="c-modal-campaign" :class="{'c-modal-campaign--show': isShowCampaign}" :style="setMvHeight">
  <div class="c-modal-campaign__bg" @click="closeModal"></div>
  <div class="c-modal-campaign__wrap">
    <div class="c-campaign-flow">
      <div class="c-campaign-flow__detail">
        <a class="c-campaign-flow__detail__close c-btn c-btn--close" @click="closeModal"></a>
        <div class="c-campaign-flow__detail__wrap">
          <h2>
            <span>PRESENT CAMPAIGN</span>
            <span>プレゼントキャンペーン<br class="u-none-b--sp">参加の流れ</span>
          </h2>
          <p>「無料相談フォーム」からお問い合わせ頂いた場合は改めてご案内します。<br>詳しい応募方法はキャンペーン紹介下部の「Amazonギフトカードプレゼント応募方法について」をご確認ください。</p>
          <dl>
            <dt>
              <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="17.5" cy="17.5" r="17.5" fill="#275231"/>
                <path d="M14.432 14.136L18.496 12.392H18.624V23H16.784V14.936L14.432 15.864V14.136Z" fill="white"/>
              </svg>
              Amazonギフトカード <br class="u-none-b--sp">最大10,000円分キャンペーン
            </dt>
            <dd>
              <picture>
                <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/campaign/webp/flow1-1-sp.webp">
                <img class="img-flow1" loading="lazy" src="/lp/assets/img/lp/campaign/webp/flow1-1-pc.webp" alt="" width="893" height="262">
              </picture>
            </dd>
            <dt>
              <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="17.5" cy="17.5" r="17.5" fill="#275231"/>
                <path d="M20.352 18.216L17.744 21.256H21.664V23H14.768V22.056L18.784 17.208C19.312 16.568 19.648 15.928 19.648 15.512C19.648 14.68 19.024 14.12 18.08 14.12C17.088 14.12 16.464 14.744 16.368 15.672L14.688 15.352C14.928 13.592 16.16 12.392 18.144 12.392C20.192 12.392 21.52 13.656 21.52 15.544C21.52 16.456 21.024 17.432 20.352 18.216Z" fill="white"/>
              </svg>
              宿泊券・ご入浴券 <br class="u-none-b--sp">プレゼントキャンペーン
            </dt>
            <dd>
              <picture>
                <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/campaign/webp/flow2-1-sp.webp">
                <img class="img-flow2" loading="lazy" src="/lp/assets/img/lp/campaign/webp/flow2-1-pc.webp" alt="" width="698" height="77">
              </picture>
            </dd>
          </dl>
        </div>
      </div>
      <div class="c-campaign-flow__btn">
        <a class="c-btn c-btn--contact-f c-btn--shadow" href="#" @click.prevent="anchor('contact')">今すぐ無料相談</a>
      </div>
    </div>
  </div>
</div>
</Transition>
</template>

<script>

import Scrollbar from 'smooth-scrollbar';
import { gsap, Quart } from 'gsap/all';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
    data() {
        return {
            mvHeight: 0,
        }
    },
    computed: {
        isShowCampaign() {
            if  (this.$store.getters.showModalCampaign) this.resize();
            return this.$store.getters.showModalCampaign;
        },
        setMvHeight() {
            if (this.mvHeight > 0) {
                return `height: ${this.mvHeight}px;`;
            } else {
                return '';
            }
        },
    },
    watch: {
        isShowCampaign(newValue, oldValue) {
            // if (newValue) {
            //     // open
            //     this.pauseScroll();
            // } else {
            //     // close
            //     this.startScroll();
            // }
        },
    },
    mounted() {
      const contents = this.$el.querySelector('.c-modal-campaign__wrap');
      Scrollbar.init(contents, {
          continuousScrolling: false,
          // delegateTo: contents,
          alwaysShowTracks: false,
      });

      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
        resize() {
            if (window.matchMedia('(max-width: 800px)').matches) {
                //SP
                this.mvHeight = innerHeight;
            } else {
                //PC
                this.mvHeight = 0;
            }
        },
        closeModal() {
          this.$store.commit('showModalCampaign', false);
        },
        pauseScroll() {
            this.$el.addEventListener('wheel', this.disableWheel, {passive: false});
            this.$el.addEventListener('touchmove', this.disableWheel, {passive: false});
            this.$el.addEventListener('keyup', this.keyboardControl, {passive: true});
        },
        startScroll() {
            this.$el.removeEventListener('wheel', this.disableWheel);
            this.$el.removeEventListener('touchmove', this.disableWheel);
            this.$el.removeEventListener('keyup', this.keyboardControl);
        },
        disableWheel(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        keyboardControl(e) {
            // Escape
            if(e.keyCode === 27) {
                this.closeModal();
            }
        },
        anchor(id) {
            this.closeModal();
            gsap.to(window, { duration: 0.8, scrollTo: { y: `#${id}`, autoKill: false }, ease: Quart.easeInOut});
        }
    }
}

</script>